import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import RoutePage from "@/pages/RoutePage";
import SandikPage from "@/pages/SandikPage";
import DavetPage from "@/pages/DavetPage";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }) {
  const { isAuthed, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-neutral-500 text-sm">
        Yükleniyor...
      </div>
    );
  }
  if (!isAuthed) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
      storageKey="oda-theme"
    >
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <Protected>
                    <Dashboard />
                  </Protected>
                }
              />
              <Route
                path="/rota"
                element={
                  <Protected>
                    <RoutePage />
                  </Protected>
                }
              />
              <Route
                path="/sandik"
                element={
                  <Protected>
                    <SandikPage />
                  </Protected>
                }
              />
              <Route
                path="/davet"
                element={
                  <Protected>
                    <DavetPage />
                  </Protected>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster richColors position="top-center" />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
